import { Component, ElementRef, EventEmitter, Input, NgZone, Output, SimpleChanges } from '@angular/core';
import { PacchettoItem } from 'src/app/_classi/PacchettoItem';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';
import { CantinaService } from 'src/app/_servizi/cantina.service';
import { MessageServiceService } from 'src/app/_servizi/message-service.service';

@Component({
  selector: 'app-pacchetti-vendibili-layout-base',
  templateUrl: './pacchetti-vendibili-layout-base.component.html',
  styleUrls: ['./pacchetti-vendibili-layout-base.component.css']
})
export class PacchettiVendibiliLayoutBaseComponent {

  get isMobile() {
    return this.appoggioService.getFromMobile();
  }

  observer!: ResizeObserver;

  checkAbilitato = false;
  abilitato = false;
  nonabilitatoMsg = '';

  idxSelezionato = null;

  @Input() isFiltrati: boolean;
  @Input() codiceForm: any;
  @Input() linguaCorrente: string;
  @Input() pacchetti: PacchettoItem[];
  pacchettiFiltered: PacchettoItem[] = [];

  pacchettoSelezionato: PacchettoItem = null;


  @Output() selezionaPacchetto = new EventEmitter<any>();

  constructor(
    private messageService: MessageServiceService,
    private cantinaService: CantinaService,
    private host: ElementRef,
    private zone: NgZone,
    private appoggioService: AppoggioService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.pacchettiFiltered = this.pacchetti;
  }



  ngOnInit(): void {
  }

  apriDettaglioPacchetto(event, pacchetto, idx) {
    if (event) {
      event.preventDefault();
    }
    this.idxSelezionato = idx;
    this.pacchettiFiltered = [];
    this.pacchettoSelezionato = pacchetto;
    this.pacchettiFiltered.push(this.pacchettoSelezionato);
    this.cantinaService.setIdxPaSelezionato(idx);
    this.selezionaPacchetto.emit(true);
  }

  goBack() {
    const idx = this.cantinaService.getIdxPaSelezionato();
    this.pacchettoSelezionato = null;
    this.pacchettiFiltered = this.pacchetti;
    if (idx) {
      this.scrollTO('pacchetto__' + idx);
    }
    this.cantinaService.setIdxPaSelezionato(null);
    this.selezionaPacchetto.emit(false);
  }

  scrollTO(target) {
    setTimeout(() => {
      document.getElementById(target).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }, 300);
  }

  contenutoPacchetto(pacchetto) {
    let contenuto = false;
    if (
      (pacchetto.vini && pacchetto.vini.length > 0) ||
      (pacchetto.inclusi && pacchetto.inclusi.length > 0) ||
      (pacchetto.opzioni && pacchetto.opzioni.length > 0)
    ) {
      contenuto = true;
    }
    return contenuto;
  }

  getCostoPacchetto(pacchetto) {
    let costo = 0;
    costo += parseFloat(pacchetto.costo);
    if (pacchetto.opzioni && pacchetto.opzioni.length > 0) {
      for (const opzione of pacchetto.opzioni) {
        if (opzione.selezionata) {
          costo += parseFloat(opzione.costo);
        }
      }
    }

    const qta = parseInt(pacchetto.qta, 10);
    if (qta > 0) {
      return costo * qta;
    } else {
      pacchetto.qta = 1;
      return costo;
    }
  }

  getQtaVini(pacchetto) {
    let totale = 0;
    for (const vino of pacchetto.vini) {
      totale += parseInt(vino.qta);
    }
    return totale;
  }

  getQtaExtra(pacchetto) {
    let totale = 0;
    for (const extra of pacchetto.inclusi) {
      totale += parseInt(extra.qta);
    }
    return totale;
  }

  countOpzioniSelezionate(pacchetto) {
    let totale = 0;
    for (const opzione of pacchetto.opzioni) {
      if (opzione.selezionata) {
        totale += 1;
      }
    }
    return totale;
  }

  hasRecensioni(pacchetto) {
    let ok = false;
    if (pacchetto.recensioni && pacchetto.recensioni.totrecensioni > 0) {
      ok = true;
    }
    return ok;
  }

  sistema(htmldescrizione: string) {
    let testodescrizione;
    if (htmldescrizione) {
      htmldescrizione = htmldescrizione.toLowerCase();
      testodescrizione = htmldescrizione;
      if (testodescrizione.length > 25) {
        testodescrizione = testodescrizione.substring(0, 25);
        testodescrizione = testodescrizione + '...';
      }
    }
    return testodescrizione;
  }

  calcGiorni(pacchetto) {
    const giorniBase = parseInt(pacchetto.giorniOffset);
    let giorniDef = giorniBase === 0 ? '1/2' : giorniBase + 1;
    return giorniDef;
  }

  promo(pacchetto) {
    if (pacchetto.sconto && pacchetto.valore_sconto != 0) {
      return true;
    } else {
      return false;
    }
  }
}
